export const handleGenericError = (dispatch, error, navigate) => {
  const statusCode = error?.response?.status ?? null;
  const message = error?.response?.data?.errors?.[0]?.message;
  const errorType = message?.errorType ?? null;
  const itemType = message?.itemType ?? null;
  if (statusCode === 404) {
    navigate('/page-not-found');
  }
  if (statusCode === 500) {
    navigate('/server-error');
  }
  if (statusCode === 401) {
    navigate('/access-denied');
  }
  if (statusCode === 403) {
    navigate('/unauthorized');
  }
  if (statusCode === 410) {
    if (errorType === 'expired') {
      navigate('/expired');
    } else {
      navigate('/unavailable', { state: { itemType } });
    }
  }
};
